import React from 'react'
import type { LifeAffectedWaysProps } from '@/features/enrollment'
import { lifeAffectedWaysOptions } from '../validation/healthLegalValidation'

export default function LifeAffectedWays({ enrollmentData, updateEnrollmentData, errors, handleCheckboxChange }: LifeAffectedWaysProps) {
  const selectedWays = (enrollmentData.lifeAffectedWays || []).filter((way: string) => way !== 'No affects from video games')
  const selectionCount = selectedWays.length
  
  return (
    <div>
      <label className="block text-sm font-medium text-accent-900 mb-2">
        Have video games affected your life in any of the following ways? <span className="text-red-500">*</span>
      </label>
      
      {/* Selection Counter */}
      <div className="mb-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-blue-800">
          <span className="font-medium">Selection Progress:</span>
          <span className={`ml-2 font-semibold ${selectionCount >= 5 && selectionCount <= 7 ? 'text-green-600' : 'text-orange-600'}`}>
            {selectionCount} of 5-7 required
          </span>
        </p>
        <p className="text-xs text-blue-600 mt-1">
          Please select between 5 and 7 life affects (excluding "No affects from video games")
        </p>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {lifeAffectedWaysOptions.map((way) => (
          <label key={way} className={`flex items-center ${way === 'No affects from video games' ? 'bg-red-50 p-2 rounded border border-red-200' : ''}`}>
            <input 
              type="checkbox" 
              name="lifeAffectedWays"
              value={way}
              checked={(enrollmentData.lifeAffectedWays || []).includes(way)}
              onChange={(e) => handleCheckboxChange('lifeAffectedWays', way, e.target.checked)}
              className="form-checkbox text-primary-600" 
            />
            <span className={`ml-2 ${way === 'No affects from video games' ? 'text-red-700 font-medium' : 'text-accent-700'}`}>
              {way}
              {way === 'No affects from video games' && (
                <span className="ml-2 text-xs text-red-600 font-bold">⚠️ WILL DISQUALIFY</span>
              )}
            </span>
          </label>
        ))}
      </div>
      
      {/* Other Affects Input */}
      {(enrollmentData.lifeAffectedWays || []).includes('Other Affects') && (
        <div className="mt-3">
          <label className="block text-sm font-medium text-accent-900 mb-2">Other Affects:</label>
          <input
            type="text"
            className="input-field w-full"
            placeholder="Specify other affects"
            value={enrollmentData.otherAffects || ''}
            onChange={(e) => updateEnrollmentData('otherAffects', e.target.value)}
          />
        </div>
      )}
      
      {errors.lifeAffectedWays && (
        <p className="mt-1 text-sm text-red-600">{errors.lifeAffectedWays}</p>
      )}
    </div>
  )
}
